import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';
import Sanitize      from '@utils/sanitize';

import ContentsModal from 'contents_modal';

import DraftContentsEdit from './draft-contents-edit';
// -------------------------------------------------------

class DraftContentsMedia extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      modal          : false,
      media_url      : '',
      modal_contents : {},
    };
  }
  // -------------------------------------------------------
  
  toggleModal(flg, media_url, media) {
    
    let contents = media;
    try { if( this.props.edit.draft_media[contents.id] != undefined ) contents = this.props.edit.draft_media[contents.id]; } catch(e) {}
    
    this.setState({ modal: flg, media_url: media_url, modal_contents: contents });
    
    if( flg == true  ) Utils.fixedContents();
    if( flg == false ) Utils.unlockFixedContents();
  }
  // -------------------------------------------------------
  
  render() {
    let data     = this.props.data;
    let edit     = this.props.edit;
    let media    = this.props.media;
    let detail   = this.props.detail;
    let contents = this.props.contents;
    contents.id = data.id;
    
    // キャプション
    let caption = null;
    caption = ( edit.caption != undefined && edit.caption[data.id] ) ? edit.caption[data.id] : contents.caption;
    try { if( caption != undefined && caption != null ) caption = Sanitize.nl2br(caption); } catch(e) {}
    
    function my_diff(a, b) {
      var array = [];
      var len = a.length;
      for (let i = 0; i < len; i++) {
        if (a.charAt(i) != b.charAt(i)) {
          array.push(i);
        }
      }
      return array;
    }
    
    try {
      let last_caption = detail.draft_caption_last_version[data.id].caption;
      try { if( last_caption != undefined && last_caption != null ) last_caption = Sanitize.nl2br(last_caption); } catch(e) {}
      
      let test = my_diff(caption, last_caption);
    } catch(e) {/*console.log(e)*/}
    
    let set_contents_type = {};
    Const.value.contents_type_list.map((d) => { if( d.id == data.media_type ) set_contents_type = d; });
    
    // リポストリスト
    let repost = [];
    try { if( detail.repost != null ) repost = detail.repost.split(','); } catch(e) {}
    if( repost.indexOf(String(contents.id)) >= 0 ){
      return (
        <div className="none">リポスト投稿になります</div>
      );
    }
    
    return (
      <div className="draft-contents-media">
        <ul className="draft-contents-box">
          { (Object.keys(set_contents_type).length > 0 && set_contents_type.caption === true) &&
            <li className="caption-box">
              <p>本文・キャプション</p>
              
              <div className="contents-item-caption">
                <div className="caption" dangerouslySetInnerHTML={{ __html: caption }} />
                <DraftContentsEdit base={this.props.base} detail={detail} contents={contents} edit={this.props.edit} table="draft_caption" update_ev={this.props.update_ev.bind(this)} />
              </div>
              
            </li>
          }
          
          { media.map((d, key) => {
            return (
              <li key={key}>
                <p>{(key + 1)}枚目</p>
                
                <div className="contents-item-media">
                  { (!Utils.isVideo(d.media_url))
                    ? <div className="thumbnail" onClick={this.toggleModal.bind(this, true, d.media_url, d)}><img src={d.media_url} /></div>
                    : <div className="thumbnail" onClick={this.toggleModal.bind(this, true, d.media_url, d)}><video src={d.media_url} /></div>
                  }
                  <DraftContentsEdit base={this.props.base} detail={detail} contents={d} edit={this.props.edit} table="draft_media" update_ev={this.props.update_ev.bind(this)} />
                </div>
              </li>
            );
          })}
        </ul>
        
        <DraftContentsMediaModal view={this.state.modal} media_url={this.state.media_url} contents={this.state.modal_contents} close_ev={this.toggleModal.bind(this)} />
      </div>
    );
  }
}
// -------------------------------------------------------

class DraftContentsMediaModal extends React.Component {
  render() {
    if( this.props.view == false ) return null;
    let contents = this.props.contents;
    
    // キャプション
    let caption = null;
    try { if( contents.revise_message != undefined && contents.revise_message != null ) caption = Sanitize.nl2br(contents.revise_message); } catch(e) {}
    
    try {
      return (
        <ContentsModal
          view      = {this.props.view}
          width     = {'80%'}
          height    = {'80%'}
          close_ev  = {this.props.close_ev.bind(this, false)}
          html      = {
            <div className="modal-item contents-item-media-modal">
              { (!Utils.isVideo(this.props.media_url))
                ? <div className="thumbnail"><img src={this.props.media_url} /></div>
                : <div className="thumbnail"><video controls src={this.props.media_url} /></div>
              }
              
              <div className="revise">
                { (contents.is_approval == 1)
                  ? <div className="revise-ok">
                      <p>●内容OK</p>
                    </div>
                  : <div className="revise-error">
                      <p>●修正依頼</p>
                      <div className="caption" dangerouslySetInnerHTML={{ __html: caption }} />
                    </div>
                }
              </div>
            </div>
          }
        />
      );
    } catch(e) {
      return null;
    }
  }
}
// -------------------------------------------------------

// レンダリング処理
export default DraftContentsMedia;